import Vue from "vue"
import VueRouter from "vue-router"

import store from "../store/store"

import Home from "../views/Home"
import Login from "../views/Login"
import Users from "../views/Users"
import Lessons from "../views/Lessons"
import Lesson from "../views/Lesson"
import Studies from "../views/Studies"
import Student from "../views/Student"
import UserOperations from "../views/UserOperations"
import NotFound from "../views/NotFound"


Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        component: Home,
        name: 'home',
        beforeEnter: (to, from, next) => {
            store.dispatch("isAuth").then(response => {
                if (response) next()
                else next({ name: 'login' })
            })
        }
    },
    {
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '/dashboard/users/:role',
        component: Users,
        name: 'users',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/dashboard/user/create/:role',
        component: UserOperations,
        name: 'createUser',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/dashboard/user/update/:user',
        component: UserOperations,
        name: 'updateUser',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/dashboard/student/:student/:token',
        component: Student,
        name: 'student',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/dashboard/lessons',
        component: Lessons,
        name: 'lessons',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/dashboard/studies',
        component: Studies,
        name: 'studies',
        beforeEnter: (to, from, next) => {
            store.dispatch("getUser", store.getters.getToken).then(response => {
                if (response.data.role === "admin") next()
                else next({ name: 'notFound' })
            })
        }
    },
    {
        path: '/lesson/:level/:lesson',
        component: Lesson,
        name: 'lesson',
        beforeEnter: (to, from, next) => {
            store.dispatch("isAuth").then(response => {
                if (response) next()
                else next({ name: 'login' })
            })
        }
    },
    {
        path: '/notFound',
        component: NotFound,
        name: 'notFound'
    },
    {
        path: '*',
        redirect: 'notFound'
    }
]


export default new VueRouter({ routes, mode: "history" })


// WEBPACK FOOTER //
// ./src/router/router.js